import { Coordinates, Optional } from '@rygen/rygen-ui/model';

export class ProposedShipmentMapDetails {
  shipmentIdentifier: number;
  stopCoordinates: Optional<Coordinates>[];
  legCoordinates: Coordinates[][];

  constructor(opts: ProposedShipmentMapDetails) {
    this.shipmentIdentifier = opts.shipmentIdentifier;

    this.stopCoordinates = opts.stopCoordinates.map((c) => {
      return c ? new Coordinates(c) : undefined;
    });

    this.legCoordinates = opts.legCoordinates.map((leg) => {
      return leg.map((c) => new Coordinates(c));
    });
  }
}
